<template>
  <div>
      <v-subheader>All Storage</v-subheader>
      <v-list-item link to="/storage">
        <v-list-item-icon>
          <v-icon>mdi-harddisk</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Search Storage</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/explore/storage">
        <v-list-item-icon>
          <v-icon>mdi-file-tree</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Explore Storage</v-list-item-title>
      </v-list-item>
      <!-- <v-subheader>My Storage</v-subheader>
      <v-list-item link to="/my/storage">
        <v-list-item-icon>
          <v-icon>mdi-harddisk</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Storage</v-list-item-title>
      </v-list-item> -->
  </div>
</template>

<script>

export default {
  name: 'MitMenuUser',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
    return {
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
